import React from "react";

export const defaultRule = (ruleType, ruleConfig) => {
    const schema = {
        normalize: (editor, error) => {
            console.log(error);
        }
    };
    if (ruleConfig.isVoid || (ruleConfig.isVoid === null && ruleConfig.nodes === null) || (ruleConfig.isVoid === undefined && ruleConfig.nodes === undefined) || (ruleConfig.nodes && !ruleConfig.nodes.length)) {
        schema.isVoid = true;
    } else {
        schema.nodes = ruleConfig.nodes;
    }
    return {
        type: ruleConfig.type,
        schema,
        rule: {
            deserialize(el, next) {
                if (el.tagName.toLowerCase() === 'component') {
                    const type = el.getAttribute('type').toLowerCase();
                    if (type === ruleType) {
                        // https://gist.github.com/nash403/5544c70fd9e8027e248239a0ef61a670
                        const data = Array.from(el.attributes)
                            .map(a => [a.name, a.value])
                            .reduce((acc, attr) => {
                                try {
                                    acc[attr[0]] = JSON.parse(attr[1]);
                                } catch (e) {
                                    acc[attr[0]] = attr[1];
                                }
                                return acc;
                            }, {});
                        const config = {
                            object: ruleConfig.type,
                            type,
                            data
                        };
                        if (schema.isVoid) {
                            config.isVoid = schema.isVoid;
                        } else {
                            config.nodes = next(el.childNodes);
                        }
                        return config;
                    }
                }
            },
            serialize(obj, children) {
                const type = obj.type;
                if (type === ruleType) {
                    // https://gist.github.com/nash403/5544c70fd9e8027e248239a0ef61a670
                    const data = Array.from(obj.data)
                        .reduce((acc, attr) => {
                            if (typeof attr[1] === "object") {
                                acc[attr[0]] = JSON.stringify(attr[1]);
                            } else {
                                acc[attr[0]] = attr[1];
                            }
                            return acc;
                        }, {});
                    if (!schema.isVoid) {
                        return <component
                            {...data}
                            type={obj.type}
                        >{children}</component>
                    } else {
                        return <component
                            {...data}
                            type={obj.type}
                        />;
                    }
                }
            }
        }
    }
};

export const defaultTagRules = {
    'link': defaultRule('link', {
        type: 'inline',
        nodes: [{ match: {object: 'text'} }],
    }),
    'figure': defaultRule('figure', {
        type: 'inline',
        isVoid: true,
    }),
    'video': defaultRule('video', {
        type: 'inline',
        isVoid: true,
    }),
};

export const TagRulesConverter = (tags, conf) => {
    const ret = conf || {
        schema: {},
        rules: []
    };
    Object.keys(tags).map((tag) => {
        if (!ret.schema[tags[tag].type + "s"]) {
            ret.schema[tags[tag].type + "s"] = {};
        }
        ret.schema[tags[tag].type + "s"][tag] = tags[tag].schema;
        ret.rules.push(tags[tag].rule);
    });
    return ret;
};